var module = angular.module('octopusApp.library');

module.controller('LibraryStepTemplatesController', function ($scope, busy, $location, pageTitle, octopusRepository, octopusPermissionSet, $filter, actionTemplateProcessor) {

    var isLoading = $scope.isLoading = busy.create();
    var isInstalling = $scope.isInstalling = busy.create();

    var addCustomStep = $location.path().indexOf('/library/steptemplates/builtin/') !== -1;
    $scope.installCommunityStep = !addCustomStep;

    $scope.installButtonName = "Install";
    $scope.addButtonName = "Add";
    $scope.resolveLink = $filter('resolveLink');

    $scope.add = function (actionType) {
        var url = "/library/steptemplates/new/" + actionType;
        $location.path(url);
    };

    $scope.install = function (id) {
        return isLoading.promise(octopusRepository.CommunityActionTemplates.get(id).then(function (template) {
            return actionTemplateProcessor.installCommunityActionTemplate(template, function (actionTemplateId) {
                return "/library/steptemplates";
            }, true, isInstalling);
        }));
    };

    $scope.update = function (id) {
        // no updates
    };

    $scope.details = function (id) {
        var url = "/library/steptemplates/community/" + id + "/details";
        $location.path(url).search("from", "communityinstall");
    };

    $scope.allTemplates = [];
    $scope.filteredLibraryTemplates = [];
    $scope.enableGrouping = true;

    $scope.filterTemplates = function () {
        $scope.enableGrouping = !(!!this.inputText);

        if (addCustomStep) {
            // Add custom step
            $scope.filteredBuiltInTemplates = actionTemplateProcessor.filterActionTemplates($scope.allTemplates, this.inputText, function (template) {
                return template.IsBuiltIn;
            });
            $scope.filteredLibraryTemplates = null;
        }
        else {
            // Add community step
            $scope.filteredBuiltInTemplates = null;
            $scope.filteredLibraryTemplates = actionTemplateProcessor.filterActionTemplates($scope.allTemplates, this.inputText, function (template) {
                return !template.IsInstalled;
            });
        }
    };

    isLoading.promise(actionTemplateProcessor.getActionTemplates().then(function (templates) {
        $scope.allTemplates = templates;
        $scope.filterTemplates();

        isLoading.promise(actionTemplateProcessor.getActionTemplatesAuthorizationAndFeatureConfig().then(function (results) {
            $scope.showActionTemplateTeaser = !results.isAuthorized;
            $scope.showLibraryTemplateTeaser = !results.configuration.IsCommunityActionTemplatesEnabled;
        }));
    }));

});






//////////////////
// WEBPACK FOOTER
// ./app/areas/library/steps/controllers/step_templates_controller.js
// module id = 468
// module chunks = 1